// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"115":"6ffddafb","328":"fb54ad74","537":"4b85f253","691":"a009c698","976":"0599fcf5"}[chunkId] + ".chunk.js";
};